function deepClone(obj: any) {
	if (typeof structuredClone !== 'undefined') {
		return structuredClone(obj);
	}

	return JSON.parse(JSON.stringify(obj));
}

export default deepClone;
